var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlamaRentCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 557.24,
    height: 269.88,
    viewBox: "0 0 557.24 269.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-2 {\n        fill: #fff;\n        font-size: 160px;\n        font-family: \"Signature\";\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.042,
    x2: 0.924,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eb4e62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed1c24"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-1006.76 -190.12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    className: "cls-1",
    d: "M31.84-55.84h32L50.24-26.72h-32L5.76,0H58.08A22.234,22.234,0,0,0,69.36-3.44a58.175,58.175,0,0,0,10.96-8.4,79.731,79.731,0,0,0,9.12-10.48A60,60,0,0,0,95.36-32L119.2-83.04h-32l13.6-29.12h32l12.48-26.72H92.96a22.058,22.058,0,0,0-11.36,3.44,61.8,61.8,0,0,0-10.96,8.4,76.633,76.633,0,0,0-9.2,10.48,60,60,0,0,0-5.92,9.68ZM92,0h66.72L171.2-26.72H147.84l37.44-80.48H141.92ZM256.48,0l35.04-75.2a43.994,43.994,0,0,0,3.04-9.68,35.43,35.43,0,0,0,.64-10.48,16.017,16.017,0,0,0-3.12-8.4q-2.64-3.44-8.08-3.44H220.16L170.24,0h28.32L215.2-35.68h14.56L213.12,0ZM236.16-80.48h14.56l-8.32,17.6H227.84ZM396.96,0,432-75.2a43.994,43.994,0,0,0,3.04-9.68,35.429,35.429,0,0,0,.64-10.48,16.017,16.017,0,0,0-3.12-8.4q-2.64-3.44-8.08-3.44H317.92L268,0h28.32l37.6-80.48h14.4L310.72,0h28.32l37.6-80.48H391.2L353.6,0Zm97.76,0,35.04-75.2a44,44,0,0,0,3.04-9.68,35.43,35.43,0,0,0,.64-10.48,16.017,16.017,0,0,0-3.12-8.4q-2.64-3.44-8.08-3.44H458.4L408.48,0H436.8l16.64-35.68H468L451.36,0ZM474.4-80.48h14.56l-8.32,17.6H466.08Z",
    transform: "translate(1001 329)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Rent_Car",
    "data-name": "Rent Car",
    className: "cls-2",
    transform: "translate(1130 428)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 0,
    y: 0
  }, "Rent a Car")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlamaRentCar);
export default __webpack_public_path__ + "static/media/slamaRentCar.f0029d364ac60328b7517409e05d34f6.svg";
export { ForwardRef as ReactComponent };